export function act(action: string, entity: string, object: any) {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    let def = this.defs[entity]
    if (def === undefined) {throw 'Invalid entity: '+ entity}

    let fn = {
        select: () => {
            if (this.editing) { return }
            this[entity] = object
            this.editing = false
            this.editing_new = false
            if (def['deselect']) { def.deselect() }
        },
        add: () => {
            this[entity] = {}
            this.form_models[entity] = this[entity]
            this.editing = true
            this.editing_new = true
        },
        edit: () => {
            let others = (def['others'] || []).concat(def['other']).filter(x=>x)
            others.map(other => {
                this.defs[other].update((o) => {
                    this.form_models[other] = angular.copy(o)
                    return o
                })
            })
            this.form_models[entity] = angular.copy(object)
            this.editing = true
        },
        save: () => {
            this.$scope.$broadcast('schemaFormValidate');
            if (!this.forms[entity] || this.forms[entity].$invalid) {
                if (this.forms[entity].$error.required) {
                    for (let element of this.forms[entity].$error.required) {
                        let title = element.$name
                        if (title) {
                            this.toaster.pop('warning', '', title.charAt(0).toUpperCase() + title.slice(1) + " field is required!")
                        }
                    }
                }
                if(this.forms[entity].$error.schemaForm[0].$name == "contact_phone"){
                    this.toaster.pop('warning', 'Invalid Phone Number', 'Phone number can only contain numbers and + - ( ) ')
                }
                else {
                    this.toaster.pop('warning', 'Validation Failed', 'Please check the form')
                }
                
            } else {
                _.assign(this[entity], this.form_models[entity])
                if (def['update']) {
                    def.update((x) => this.form_models[entity])
                }
                let others = (def['others'] || []).concat(def['other']).filter(x=>x)
                others.map(other => {
                    this.defs[other].update((o) => this.form_models[other])
                })
                if (this.editing_new) {
                    def.update_list((xs) => xs.concat(this.form_models[entity]))
                }
                this.save_page()
            }
        },
        discard: () => {
            this.editing = false
            if (this.editing_new) {
                this[entity] = null
            }
            this.editing_new = false
            this.form_models = {}
        },
        delete: () => {
            def.update_list((xs) => xs.filter((x) => x !== object))
            this[entity] = null
            this.form_models = {}
            this.save_page()
        }
    }[action]
    if (fn === undefined) { throw 'Invalid action: ' + action }
    fn()
}


export function get_leave_config(employee ,org, schema) {
    var r : any = {}
    r.carried_forward = _.get(org.extra, 'leave.carried_forward')
    r.leave_start_date = _.get(employee.extra, 'leave.start_date', _.get(employee.extra, 'employment.start_date'))
    r.paid_leave_days_per_year = _.get(employee.extra, 'leave.paid_leave_days_per_year', _.get(org.extra, 'leave.paid_leave_days_per_year', schema.properties.leave.properties.paid_leave_days_per_year.default))
    r.sick_leave_days_per_year = _.get(employee.extra, 'leave.sick_leave_days_per_year', _.get(org.extra, 'leave.sick_leave_days_per_year', schema.properties.leave.properties.sick_leave_days_per_year.default))
    r.maternity_leave_days_per_year = _.get(employee.extra, 'leave.maternity_leave_days_per_year', _.get(org.extra, 'leave.maternity_leave_days_per_year', schema.properties.leave.properties.maternity_leave_days_per_year.default))
    r.paid_leave_carried_forward = _.get(employee.extra, 'leave.paid_leave_carried_forward', 0)
    r.sick_leave_carried_forward = _.get(employee.extra, 'leave.sick_leave_carried_forward', 0)
    r.maternity_leave_carried_forward = _.get(employee.extra, 'leave.maternity_leave_carried_forward', 0)
    r.work_days = get_work_days(org)
    return r
}


export function leave_balance(type, leave_config, lb: any, ldpy: any, start: any, end: any, is_hijacked: boolean) {
    if (type != 'paid' && type != 'sick' && type != 'maternity') { return NaN }
        var leave_start_date = _.get(leave_config, 'contract_start_date', '')
    if(!leave_start_date) { return NaN }
    if (!(start && end)) { return NaN }

    let today = moment({hour: 0})
    var balance_today = lb[type]
    var years_today = today.diff(moment(leave_start_date), 'years')
    var years_end = end.diff(leave_start_date, 'years')
    var balance_end = ((years_end - years_today) > 0 && balance_today > 0)
                          ? ( balance_today % ldpy["carried_forward"] == 0 )
                            ? ldpy["carried_forward"] + ldpy[type]
                            : balance_today % ldpy["carried_forward"] + ldpy[type]
                          : balance_today

    if (end.isBefore(start)) { return NaN }
    if (start.isBefore(today) && !is_hijacked) {return NaN}

    var total = 0;
    for (var i = 0; moment(start).add(i, 'days').isSameOrBefore(end); i++) {
        var day = moment(start).add(i, 'days')

        if (_.includes(leave_config.work_days, day.day())) {
            total += 1;
        }
    }
    if (total <= 0) { return NaN }
    return balance_end - total
}


export function get_locale_date_format(){
  return (<any>new Intl.DateTimeFormat()).resolved.pattern.replace(/\//g,".")
}

export function ExternalUrl(url: string): string {
    var url: string = url.match(/^http[s]*:\/\//) ? url : 'http://' + url;
    return url;
}

export function deepMerge(target:any, source:any) {
    for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
            if (target[prop] && typeof source[prop] === 'object') {
                this.deepMerge(target[prop], source[prop]);
            }
            else {
                target[prop] = source[prop];
            }
        }
    }
    return target;
}

export function get_work_days(org){
  var days = {'Sunday': 0,'Monday': 1,'Tuesday': 2,'Wednesday': 3,'Thursday': 4,'Friday': 5,'Saturday': 6}
  var work_week_start =  days[_.get(org.extra, "leave.work_week_start", "Sunday")]
  var work_week_end = days[_.get(org.extra, "leave.work_week_end", "Thursday")]
  var work_days: any
  if (work_week_start > work_week_end){
    work_days = [0,1,2,3,4,5,6].filter(function(i){
      if (!(_.includes(_.range(work_week_end+1, work_week_start),i))){
        return true
      }})
  }else if(work_week_start < work_week_end){
    work_days = _.range(work_week_start, work_week_end+1)
  }else{
    work_days = [work_week_start]
  }
  return work_days
}

export function get_work_days_from_workweek(work_week){
  var days = {'Sunday': 0,'Monday': 1,'Tuesday': 2,'Wednesday': 3,'Thursday': 4,'Friday': 5,'Saturday': 6}
  var work_week_start =  days[work_week.startDay];
  var work_week_end = days[work_week.endDay];
  var work_days: any
  if (work_week_start > work_week_end){
    work_days = [0,1,2,3,4,5,6].filter(function(i){
      if (!(_.includes(_.range(work_week_end+1, work_week_start),i))){
        return true
      }})
  }else if(work_week_start < work_week_end){
    work_days = _.range(work_week_start, work_week_end+1)
  }else{
    work_days = [work_week_start]
  }
  return work_days
}

export function getRoleFromClearance (clearance: string): string {
  switch (clearance) {
  case "admin":
    return "hrm";
  case "audit":
    return "c-level";
  case "edit":
    return "hr";
  case "":
    return "regular";
  default:
    return "unkown";
  }
}



// WEBPACK FOOTER //
// ./frontend/scripts/global/functions.ts